import { render, staticRenderFns } from "./PaperTest.vue?vue&type=template&id=f85b7efc&style=height%3A%20100%25%3B"
import script from "./PaperTest.vue?vue&type=script&lang=js"
export * from "./PaperTest.vue?vue&type=script&lang=js"
import style0 from "./PaperTest.vue?vue&type=style&index=0&id=f85b7efc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports